import NajActionButton from './naj-action-button/naj-action-button';
import NajAddress from './naj-address';
import NajBox from './naj-box';
import NajConfirmation from './naj-confirmation';
import NajDataTable from './naj-data-table';
import NajDateRange from './naj-date-range';
import NajDynamicField from './naj-dynamic-field';
import NajReadonlyInput from './naj-readonly-input';
import NajModal from './naj-modal';
import NajModal2 from './naj-modal-2';
import NajSocialIdentityInput from './naj-social-identity-input';
import NajNoData from './naj-no-data.vue';
import NajDataRow from './naj-data-row';
import NajSearchBox from './naj-search-box';
import NajArchiveIcon from './naj-archive-icon';
import NajItemTable from './naj-item-table';
import NajButton from './naj-button/naj-button';
import NajInput from './naj-input';
import NajAttachment from './naj-attachment';
import NajDynamicForm from './naj-dynamic-form';

export default {
  NajActionButton,
  NajAddress,
  NajBox,
  NajConfirmation,
  NajDataTable,
  NajModal,
  NajModal2,
  NajDateRange,
  NajSocialIdentityInput,
  NajDynamicField,
  NajNoData,
  NajReadonlyInput,
  NajDataRow,
  NajItemTable,
  NajSearchBox,
  NajArchiveIcon,
  NajButton,
  NajInput,
  NajAttachment,
  NajDynamicForm,
};
